import {
  Backdrop,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { FC, ReactNode } from "react";

type GuideLayoutProps = {
  children: ReactNode;
  loading?: boolean;
  loadingText?: string;
};

export const GuideLayout: FC<GuideLayoutProps> = ({
  children,
  loading = false,
  loadingText = "Loading...",
}) => {
  return (
    <>
      <Card
        raised
        sx={{
          maxWidth: { sm: 680, xs: "100%" },
          width: "100%",
          height: { xs: "100vh", sm: "auto" },
          margin: "0 auto",
          padding: { sm: "1em", xs: 0 },
          marginTop: { sm: "2em", xs: "1em" },
          marginBottom: { sm: "2em", xs: 0 },
          overflow: "auto",
        }}
      >
        <CardMedia
          component="img"
          height="200"
          alt="VetNebula"
          sx={{
            objectFit: "contain",
            maxWidth: { sm: 280, xs: 240 },
            margin: "0 auto",
            px: 1,
            pt: 1,
          }}
          image="/images/logo.png"
        />
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            backgroundColor: "white",
            px: { xs: 2, sm: 3 },
            pb: 3,
          }}
        >
          {children}
        </CardContent>
      </Card>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Stack direction="column" alignItems="center">
          <CircularProgress color="inherit" />
          <Typography variant="subtitle2" noWrap>
            {loadingText}
          </Typography>
        </Stack>
      </Backdrop>
    </>
  );
};
